import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { IHCPhoneWorkingHours } from "@faire/web-api/indigofair/helpcenter/IHCPhoneWorkingHours";
import { HELP_CENTER_PHONE_WORKING_HOURS } from "@faire/web-api/indigofair/settings/HELP_CENTER_PHONE_WORKING_HOURS";
export function getSettingPhoneWorkingHours() {
  return getSettingValueWithoutAssignment(HELP_CENTER_PHONE_WORKING_HOURS, IHCPhoneWorkingHours.build({
    // 9 in hour
    start_at: 32400000,
    // 20 in hour
    end_at: 72000000,
    timezone: "America/New_York"
  }));
}